import React from "react";
import { useSelector } from "react-redux";
import { orderBy } from "lodash";

// components (global)
import { CustomTabs } from "components/Tabs";

// components (local)
import { AccessGroupTab, AccessLevelTab, LiftAccessTab } from "./components";

// material-ui
import { makeStyles } from "@material-ui/core/styles";

// styles
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  tab: {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
}));

const VendorAccessTab = () => {
  const classes = useStyles();

  // selector
  const selectedVendor = useSelector((state) => state.main.selectedVendor);
  const vendor = useSelector((state) => {
    return state.firestore.data.vendors
      ? state.firestore.data.vendors[selectedVendor]
      : null;
  });

  let tabs = [
    {
      value: "access_group",
      label: "Access Group",
      sorting: 1,
      content: <AccessGroupTab />,
    },
    {
      value: "lift_access",
      label: "Lift Access",
      sorting: 2,
      content: <LiftAccessTab />,
    },
  ];

  if (vendor.access_card_settings.type.toLowerCase() === "entrypass") {
    tabs = {
      ...tabs,
      tabs: {
        value: "access_level",
        label: "Access Level",
        sorting: 0,
        content: <AccessLevelTab />,
      },
    };
  }

  return (
    <div className={classes.root}>
      <CustomTabs
        tabs={orderBy(tabs, ["sorting"], ["asc"])}
        orientation="vertical"
        defaultTabIndex={0}
      />
    </div>
  );
};

export default VendorAccessTab;
